import Vue from 'vue'
import { toRelativeUrl } from '@/utils/internalUrl'

export default Vue.extend({
  methods: {
    toRelativeUrl (url: string | null | undefined): string {
      return toRelativeUrl(url)
    }
  }
})
